/**
 * Where the admin lives. The two systems share one account but not one origin —
 * sys.viganium.net and admin.viganium.net in production, :5174 and :5173 in
 * development — so the address is worked out from this page's own, and
 * VITE_ADMIN_URL overrides the guess for any setup that breaks the pattern.
 */
export function adminUrl(): string {
  const configured = import.meta.env.VITE_ADMIN_URL;
  if (configured) return configured.replace(/\/$/, '');

  const { protocol, hostname, port } = window.location;
  if (hostname.startsWith('sys.')) return `${protocol}//admin.${hostname.slice('sys.'.length)}`;
  if (port === '5174') return `${protocol}//${hostname}:5173`;
  return `${protocol}//admin.${hostname}`;
}
